module.exports = __webpack_public_path__ + "536abee651a9ad28d402dcc79a3629a7.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2019-04-04/whats-new.html
// module id = 2306
// module chunks = 0